import React from "react";
import ItemBase from "../../common/components/ItemBase";
import branch from "../../common/containers/branch";

export class Item extends ItemBase {
	constructor(props, context) {
		super(props, context);
	}

	renderAfterLoad() {
		return (
			<li>
				<img
					src={this.props.item.imageUrl}
					onError={(e) => {
						e.target.src =
							"https://app-9015f501-af0b-463a-b954-ab7059b01626.apps.meo.pt/images/images/img_ndisp_meo.png";
					}}
					alt={this.props.item.name}
				/>
				<div className="item-description">
					<p>{this.props.item.name}</p>

					{/* -= INSTALLMENTS =- */
					this.hasNumber(this.props.item.monthlyPrice) &&
						this.hasNumber(this.props.item.price) && (
							<p>
								{this.getPriceCurrency(this.props.item.monthlyPrice)}/mês x{" "}
								{this.props.item.months} +{" "}
								{this.getPriceCurrency(this.props.item.price)}
							</p>
						)}

					{/* -= PROMPT PAYMENT =- */
					!this.hasNumber(this.props.item.monthlyPrice) &&
						this.hasNumber(this.props.item.price) &&
						!this.hasNumber(this.props.item.pointsPrice) && (
							<p>{this.getPriceCurrency(this.props.item.price)}</p>
						)}

					{/* -= POINTS =- */
					!this.hasNumber(this.props.item.monthlyPrice) &&
						this.hasNumber(this.props.item.pointsPrice) && (
							<p>
								{this.props.item.pointsPrice} MEOS
								{this.hasNumber(this.props.item.price) && (
									<React.Fragment>
										+ {this.getPriceCurrency(this.props.item.price)}
									</React.Fragment>
								)}
							</p>
						)}
				</div>
			</li>
		);
	}

	render() {
		return this.renderContent(false);
	}
}

export default branch(Item);
